import React from 'react';
import PropTypes from 'prop-types';
import { CDN_TYPE_SPORT, getCDNUrl } from 'utils';

import { Flag } from '@atlas/ui';

const LangSwitchSmallCover = ({
  getCurrentRegionId,
  getCurrentRegionName,
  isLanguageTypeFlag,
  isLanguageTypeISO,
  isSmall,
  lang,
}) => {
  if (!isSmall) return null;

  if (isLanguageTypeFlag && getCurrentRegionId) {
    return (
      <Flag
        alt={getCurrentRegionName}
        cdnHostname={getCDNUrl(CDN_TYPE_SPORT)}
        name={getCurrentRegionId}
      />
    );
  }

  if (isLanguageTypeISO) {
    return <span>{lang}</span>;
  }

  return null;
};

LangSwitchSmallCover.propTypes = {
  isLanguageTypeFlag: PropTypes.bool,
  isLanguageTypeISO: PropTypes.bool,
  isSmall: PropTypes.bool,
  lang: PropTypes.string,
};

export default LangSwitchSmallCover;
